export function briefProfileForMarketCountryChange(
  profile,
  marketCountry,
  defaultSectionIds,
  defaultSequenceVersion,
) {
  const source = profile && typeof profile === "object" && !Array.isArray(profile) ? profile : {};
  const country = String(marketCountry || "US")
    .trim()
    .toUpperCase()
    .slice(0, 2);
  const userCustomized =
    source.purpose === "custom" ||
    Boolean(String(source.templateId || "").trim()) ||
    String(source.name || "Daily Brief").trim() !== "Daily Brief";
  if (userCustomized) return { ...source, marketCountry: country };
  return {
    ...source,
    name: "Daily Brief",
    depth: "balanced",
    preferredLength: "balanced",
    marketCountry: country,
    sectionIds: Array.isArray(defaultSectionIds) ? [...defaultSectionIds] : [],
    disabledSectionIds: [],
    ...(String(defaultSequenceVersion || "").trim()
      ? { sequenceVersion: String(defaultSequenceVersion).trim() }
      : {}),
    styleId: "daily",
    templateId: "",
    purpose: "daily_clarity",
    tone: "calm",
    timeOfDay: "morning",
    narrationEnabled: false,
  };
}
